import {
  createStyles,
  fade,
  TableCellProps,
  Theme,
  withStyles,
} from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyExtraSmall from 'ui-elements/typography/FsBodyExtraSmall';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import { purple } from 'globals/colors';
import FsBodyExtraSmallBold from 'ui-elements/typography/FsBodyExtraSmallBold';

interface AdditionalCellProps {
  withIconOnly?: boolean;
}

export const Name = withStyles({})(FsBody);

export const Email = withStyles(({ palette }: Theme) =>
  createStyles({
    root: {
      color: palette.grey[400],
    },
  })
)(FsBodyExtraSmall);

export const Row = withStyles(({ palette }: Theme) =>
  createStyles({
    root: {
      background: palette.common.white,
      transition: 'background .3s linear',
      '&.MuiTableRow-hover': {
        cursor: 'pointer',
        background: palette.common.white,
        '&:hover': {
          background: palette.grey[100],
        },
      },
      '&.Mui-selected': {
        background: `${fade(purple.V5, 0.5)} !important`,
      },
      '&.isLast :is(td, th)': {
        borderBottom: 0,
      },
    },
  })
)(TableRow);

export const Reference = withStyles(() =>
  createStyles({
    root: {
      whiteSpace: 'nowrap',
    },
  })
)(FsBodySmall);

export const HeadCell = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      padding: spacing(2, 1),
      borderBottom: `1px solid ${palette.grey[200]}`,
    },
  })
)(({ withIconOnly, ...otherProps }: TableCellProps & AdditionalCellProps) => {
  return (
    <TableCell
      {...otherProps}
      style={{
        width: withIconOnly ? 24 : undefined,
      }}
    />
  );
});

export const HeadLabel = withStyles(({ palette }: Theme) =>
  createStyles({
    root: {
      color: palette.grey[300],
      textTransform: 'uppercase',
    },
  })
)((props) => <FsBodyExtraSmallBold component="span" {...props} />);

export const Cell = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      padding: spacing(2, 1),
      borderBottom: `1px solid ${palette.grey[200]}`,
    },
  })
)(({ withIconOnly, ...otherProps }: TableCellProps & AdditionalCellProps) => {
  return (
    <TableCell
      component="td"
      scope="row"
      {...otherProps}
      style={{
        width: withIconOnly ? 24 : undefined,
      }}
    />
  );
});
